export default __webpack_public_path__ + "static/media/icon_big_match_status.637a36f7.svg";